import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { getLocaleConfig } from '@global/localization/services';

export const SchoolStepSchema = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'activeForm.validationErr',
  });
  return yup.object({
    state: yup.string().when('country', (country) => {
      const stateSchema = yup.string().trim();
      const { stateDropdown, stateDropdownLabel } = getLocaleConfig(country);
      const requireError = `${t('stateReq')} ${stateDropdownLabel}`;
      return stateDropdown ? stateSchema.required(requireError) : stateSchema;
    }),
    school: yup.string().required(t('schoolReq')),
    country: yup.string().required(),
  });
};
